import { resolveOfficeHost } from "../office/officeHost";
import type { FinsterHostInfo, OfficeHost } from "../office/officeHost";

export type AnalyticsHost = OfficeHost;
export const ANALYTICS_APP_SOURCE = "finster_office_addin";

export type { FinsterHostInfo };

export function resolveAnalyticsHost(): AnalyticsHost | null {
  return resolveOfficeHost();
}

let deploymentAppEnv = "unknown";

export function setAnalyticsDeploymentAppEnv(appEnv: string): void {
  deploymentAppEnv = appEnv || "unknown";
}

/** Attached to every event so dashboards stay consistent across hosts. */
export function getGlobalEventProperties(): Record<string, string | boolean> {
  const host = resolveAnalyticsHost();
  const hostInfo = window.__FINSTER_HOST_INFO__;

  return {
    appSource: ANALYTICS_APP_SOURCE,
    ...(host ? { host } : {}),
    platform: hostInfo?.platform ?? "unknown",
    officeHost: hostInfo?.host ?? "unknown",
    officeJsAvailable: hostInfo?.officeJsAvailable ?? false,
    appEnv: deploymentAppEnv,
    surface: "task_pane",
  };
}
